import React from 'react';
import site from '../content/siteContent';

export default function About() {
  return (
    <div className="min-h-screen bg-sand/5">
      {/* Hero Section */}
      <div className="bg-wood text-sand py-16">
        <div className="container">
          <h1 className="text-4xl font-bold mb-4">About {site.name}</h1>
          <p className="text-sand/90 max-w-2xl text-content">
            Learn about our journey, our values, and the advanced machinery that enables us to
            deliver exceptional interior solutions.
          </p>
        </div>
      </div>

      <div className="container py-12">
        <section className="mt-8">
          <h2 className="text-2xl font-semibold">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
            <div className="card p-4">
              <h3 className="font-semibold mb-2">Precision</h3>
              <p className="text-neutralText">
                We maintain strict tolerances and QA for every project, ensuring perfect execution.
              </p>
            </div>
            <div className="card p-4">
              <h3 className="font-semibold mb-2">Quality Materials</h3>
              <p className="text-neutralText">
                We specify materials for longevity and aesthetic consistency.
              </p>
            </div>
            <div className="card p-4">
              <h3 className="font-semibold mb-2">Client Collaboration</h3>
              <p className="text-neutralText">
                We iterate with clients to deliver functional, beautiful spaces.
              </p>
            </div>
          </div>
        </section>

        <section className="mt-12">
          <h2 className="text-2xl font-semibold mb-6">Our Advanced Machinery</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Panel Saw',
                image: '/images/processed/machinery/machine-panelsaw--1200x900.jpg',
                description:
                  'High-precision panel saw for accurate cutting and sizing of wood panels and boards.',
              },
              {
                name: 'Edge Bander',
                image: '/images/processed/machinery/machine-edgebander--1200x900.jpg',
                description: 'Professional edge banding machine for seamless edge finishing.',
              },
              {
                name: 'Cold Press',
                image: '/images/processed/machinery/machine-panelsaw-8468-1200x900.jpg',
                description: 'Industrial cold press machine for lamination and veneering.',
              },
            ].map((machine) => (
              <div key={machine.name} className="card overflow-hidden group">
                <div className="relative">
                  <img
                    src={machine.image}
                    srcSet={`${machine.image.replace('1200x900', '400x300')} 400w,
                            ${machine.image.replace('1200x900', '800x600')} 800w,
                            ${machine.image} 1200w`}
                    sizes="(max-width: 768px) 100vw, 33vw"
                    alt={machine.name}
                    loading="lazy"
                    className="w-full aspect-4/3 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <div className="text-white text-center p-4">
                      <h3 className="text-xl font-semibold mb-2">{machine.name}</h3>
                      <p className="text-sm">{machine.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Additional machinery details */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-xl font-semibold">Advanced Manufacturing</h3>
              <p className="text-neutralText text-content">
                Our state-of-the-art machinery enables us to deliver precision woodworking and
                superior finishes. From accurate panel cutting to seamless edge banding and
                professional lamination, our advanced equipment ensures consistent quality across
                all projects.
              </p>
            </div>
            <div className="space-y-4">
              <h3 className="text-xl font-semibold">Quality Assurance</h3>
              <p className="text-neutralText text-content">
                Every piece of machinery is regularly maintained and calibrated to meet the highest
                industry standards. Our skilled operators combine their expertise with these
                advanced tools to create exceptional interior solutions that stand the test of time.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
